module.exports = __webpack_public_path__ + "images/checkbox-alt-checked.svg";